/* eslint-disable react/jsx-max-depth */
import '@stripe/stripe-js';
import React, { lazy, Suspense } from 'react';
import { render } from 'react-dom'; // todo: fix, this is deprecated; see https://react.dev/blog/2022/03/08/react-18-upgrade-guide#updates-to-client-rendering-apis
import { Provider } from 'react-redux';
import { Route, Router, Switch } from 'react-router-dom';
import '../public/scss/main.scss';
import PublicApp from './PublicApp/PublicApp';
import { MapViewProvider } from './components/mapView/mapViewContext';
import { startListener } from './events/serviceWorkerEventListener';
import App from './pages/App';
import history from './routes/history';
import registerServiceWorker from './serviceWorkers/registerServiceWorker';
import { store } from './utilities';
import { setupInterceptors } from './utilities/api';
import PrivateRoute from './mp/components/PrivateRoute';
// import NewRealtimeMapPage from './mp/pages/new';
// import RealtimeMapPage from './mp/pages/mp';
import routes from './routes/constants';
import PreviewTestPage from './pages/previewTest';
import Loading from './components/loading/Loading';
import TestPdfPage from './pages/testPdf';
import Onboarding from './pages/dashboard/components/onboarding';
import { TourProvider } from '@reactour/tour';
import TourContent from './pages/dashboard/components/onboarding/tour/TourContent';
import TestSvgPage from './pages/testSvg';

setupInterceptors(store);

const RealtimeMapPage = lazy(() => import('./mp/pages/mp'));
const NewRealtimeMapPage = lazy(() => import('./mp/pages/new'));

render(
  <Provider store={store}>
    <TourProvider
      steps={[]}
      ContentComponent={TourContent}
      onClickMask={() => {}}
    >
      <Router history={history}>
        <Suspense fallback={<Loading />}>
          <Switch>
            <PrivateRoute
              exact
              path={routes.mp.job()}
              component={RealtimeMapPage}
            />
            <PrivateRoute
              exact
              path={routes.mp.root}
              component={NewRealtimeMapPage}
            />
            <Route exact path='/preview-test' component={PreviewTestPage} />
            <Route exact path='/pdf' component={TestPdfPage} />
            <Route exact path='/svg' component={TestSvgPage} />
            <MapViewProvider>
              <Route path='/embed' component={PublicApp} />
              <Route path='/' component={App} />
            </MapViewProvider>
          </Switch>
        </Suspense>
      </Router>
      <Onboarding />
    </TourProvider>
  </Provider>,
  document.getElementById('root')
);

if (process.env.ENABLE_SERVICE_WORKER) {
  startListener();
  registerServiceWorker();
}
